




























import { useOnEntry } from '@front-app/hooks/useOnEntry';
import { Address } from '@front-app/services/SharedModels';
import { formatPhoneNumber } from '@front-app/util/format';
import { Size } from '@front-app/components/constants';
import { defineComponent, PropType, ref } from '@vue/composition-api';
import LoaderState from '../../../components/LoaderState.vue';
import SearchResult from '../../../components/search/SearchResult.vue';
import TrAddress from '../../../components/TrAddress.vue';

export default defineComponent({
	components: { SearchResult, TrAddress, LoaderState },
	props: {
		phoneNumber: {
			type: String,
			default: '',
		},
		address: {
			type: Object as PropType<Address>,
			required: false,
			default: () => ({}),
		},
		isAddressLoading: Boolean,
	},
	setup(props, ctx) {
		const el = ref(null);
		const callback = () => {
			ctx.emit('is-visible');
		};
		// eslint-disable-next-line @typescript-eslint/no-empty-function
		const unsupportedCallback = () => {};
		useOnEntry(el, callback, unsupportedCallback);
		return {
			el,
			Size,
			formatPhoneNumber,
		};
	},
});
